<template>
  <b-row>
    <b-col>
      <b-row class="mx-1 my-2">
        <b-overlay rounded="sm" :show="loading">
          <b-col cols="12">
            <b-row v-for="(message, idx) in messages" :key="idx">
              <b-col cols="6" class="py-2 rounded-md bg-header_grey my-2 text-gray">
                <b-row>
                  <b-col>
                    <span class="text-sm font-bold text-capitalize">
                      {{ sender(message) }}
<!--                      <b-badge class="bg-green text-capitalize">{{ senderRole(message) }}</b-badge>-->
                    </span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <span class="text-sm">{{ comment(message) }}</span>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <span style="font-size:9px">{{ dateFormat(createdAt(message)) }}</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row v-if="messages.length === 0">
              <b-col cols="11" class="mx-auto rounded-md bg-header_grey my-2 text-gray">
                <b-row>
                  <b-col>
                    <span class="text-xs font-bold">No messages yet</span>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-overlay>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import moment from "moment";
import { api } from "../../../../../../app/services/api.service";

export default {
  name: "TaskMessages",
  props: {
    taskId: {
      type: String,
      default: "",
    },
    taskType: {
      type: String,
      default: "nir",
    },
  },
  data() {
    return {
      loading: false,
      messages: [],
    };
  },
  watch: {
    taskId: {
      handler() {
        this.fetchMessages();
      },
      immediate: true,
    },
  },
  methods: {
    fetchMessages() {
      const type = (this.taskType || "").toLowerCase();
      if ( type.includes("forced_registration")) {
        this.messages = [];
        this.loading = false;
        return;
      }
      this.loading = true;
      let url = "/nir/api/v1/applications/task/queries?id=";
      if (this.taskType === "nir-affiliations") {
        url = "/nir/api/v1/affiliations/task/queries?id=";
      } else if (this.taskType === "amendments") {
        url = "/nir/api/v1/amendments/task/queries?id=";
      } else if (this.taskType === "data-updates") {
        url = "/nir/api/v1/data-updates/task/queries?id=";
      }
      
      api()
        .get(url + encodeURIComponent(this.taskId))
        .then(function (res) {
          const payload = res && res.data ? res.data.data : null;
          if (Array.isArray(payload)) {
            this.messages = payload;
          } else if (payload && Array.isArray(payload.data)) {
            this.messages = payload.data;
          } else if (payload && Array.isArray(payload.content)) {
            this.messages = payload.content;
          } else {
            this.messages = [];
          }
          this.loading = false;
        }.bind(this))
        .catch(function (error) {
          this.loading = false;
          this.messages = [];
          if (typeof this.errorToast === "function") {
            const msg =
              (error && error.response && error.response.data && (error.response.data.message || error.response.data.error)) ||
              "Failed to load messages";
            this.errorToast("Error", msg);
          }
        }.bind(this));
    },
    sender(message) {
      if (message && message.sender) {
        return String(message.sender).toLowerCase();
      }
      if (message && message.senderId) {
        return String(message.senderId);
      }
      if (message && message.messageData && message.messageData.sender) {
        return String(message.messageData.sender).toLowerCase();
      }
      return "unknown";
    },
    senderRole(message) {
      if (message && message.senderRole) {
        return String(message.senderRole).toLowerCase();
      }
      if (message && message.messageData && message.messageData.senderRole) {
        return String(message.messageData.senderRole).toLowerCase();
      }
      return "user";
    },
    comment(message) {
      if (message && message.message) {
        return message.message;
      }
      if (message && message.messageData && message.messageData.comment) {
        return message.messageData.comment;
      }
      return "—";
    },
    createdAt(message) {
      if (message && message.createdAt) {
        return message.createdAt;
      }
      if (message && message.messageData && message.messageData.createdAt) {
        return message.messageData.createdAt;
      }
      return null;
    },
    dateFormat(date) {
      if (!date) return "—";
      return moment(date).format("DD-MM-YYYY HH:mm");
    },
  },
};
</script>

<style scoped>
</style>
